import { z } from 'zod/v4';

import { coercedDate } from '../../../utils/coerced-date';

export const placesPlaceSetSchema = z.object({
  setId: z.number(),
  name: z.string(),
  placeCounts: z.number(),
  lastModified: coercedDate,
});

export type PlacesPlaceSet = z.infer<typeof placesPlaceSetSchema>;
